/**
 * @ngdoc controllers
 * @memberof mercury.modules.qa.bepoz
 * @name QaBepozProductSummaryCtrl
 * @description A report that replicates the Product summary from the Bepoz back office
 */
angular.module('mercury.modules.qa.wizbang')
.controller('QaWizbangTransactionsCtrl', ["$filter", "reporttime", "$q", "$scope", "$http", "$stateParams", "title", "userinfo", "settings", function($filter, reporttime, $q, $scope, $http, $stateParams, title, userinfo, settings) {
  title.set('Transaction Listing Report');

  $scope.companyName = userinfo.companyName();

  $scope.loading = $http.get(settings.apiHost + '/r/PosQaWizbangTransactions', {
    params: {startTime: reporttime.start(), endTime: reporttime.end()}}
  );

  $scope.reportLines = [];
  $scope.tip = 0;
  $scope.change = 0;
  $scope.tendered = 0;

  var updateTotals = function(object, item) {

    object.tip += item.tenderLineTip;
    object.change += item.tenderLineChange;
    object.tendered += item.tenderLineAmount;

  };

  $scope.loading.then(function(response) {
    title.setSubheader(response.data.notes);

    // First we place the lines in a heirachy, then flatten it to make the lines in the table
    // var reportOutlets = {};
    var reportOutletLine = {};
    angular.forEach(response.data.lines, function(item) {
      if (!item.superItemGroupId) {
        item.superItemGroupId = -1;
      }

      if (!item.outletId) {
        item.outletId = -1;
        item.outletName = '';
      }

      if (!item.superItemGroupOrder) {
        item.superItemGroupOrder = 0;
      }

      //Group Into Outlets
      if (!reportOutletLine[item.outletId]) {
        reportOutletLine[item.outletId] = {
          id: item.outletId,
          name: item.outletName,
          whenTendered: item.whenTendered,
          till: {},
          tenderLineType: 0,
          invoiceTotal: 0,
          total: 0,
          tip: 0,
          change: 0,
          tendered: 0
        };
      }

      //Group Into Tills
      if (!reportOutletLine[item.outletId].till[item.tillId]) {
        reportOutletLine[item.outletId].till[item.tillId] = {
          id: item.tillId,
          name: item.tillName,
          whenTendered: item.whenTendered,
          tenderItemGroups: {},
          tenderLineType: 0,
          invoiceTotal: 0,
          total: 0,
          tip: 0,
          change: 0,
          tendered: 0
        };
      }

      if (!reportOutletLine[item.outletId].till[item.tillId].tenderItemGroups[item.tenderLineTypeId]) {
        reportOutletLine[item.outletId].till[item.tillId].tenderItemGroups[item.tenderLineTypeId] = {
          id: item.tenderLineTypeId,
          name: item.tenderLineType,
          order: item.tenderLineTypeOrder,
          whenTendered: item.whenTendered,
          items: [],
          tenderLineType: 0,
          invoiceTotal: 0,
          tip: 0,
          change: 0,
          tendered: 0
        };
      }

      reportOutletLine[item.outletId].till[item.tillId].tenderItemGroups[item.tenderLineTypeId].items.push({
        isItemLine: true,
        isValueLine: true,
        id: item.invoiceId,
        whenTendered: item.whenTendered,
        // itemName: item.itemAbbrev,
        tenderLineType: item.tenderLineType,
        invoiceTotal: item.invoiceTotal,
        tip: item.tenderLineTip,
        change: item.tenderLineChange,
        tendered: item.tenderLineAmount
      });

      updateTotals(reportOutletLine[item.outletId].till[item.tillId].tenderItemGroups[item.tenderLineTypeId], item);
      updateTotals(reportOutletLine[item.outletId].till[item.tillId], item);
      updateTotals(reportOutletLine[item.outletId], item);

      $scope.tip += item.tenderLineTip;
      $scope.change += item.tenderLineChange;
      $scope.tendered += item.tenderLineAmount;

      console.log($scope.tendered);
    });

    angular.forEach(reportOutletLine, function(outlet) {
      $scope.reportLines.push({
        isHeader: true,
        headerText: outlet.name + ' - ' + $scope.companyName
      });

      angular.forEach(outlet.till, function(till) {

        $scope.reportLines.push({
          isHeader: true,
          headerText: till.name
        });

        // convert to plain array to allow sorting
        var tenderItemGroupsArray = [];
        angular.forEach(till.tenderItemGroups, function(tenderItemGroup) {
          tenderItemGroupsArray.push(tenderItemGroup);
        });
        angular.forEach($filter('orderBy')(tenderItemGroupsArray, 'order'), function(tenderItemGroup) {
          if (tenderItemGroup.name) {
            /**
            $scope.reportLines.push({
              isHeader: true,
              headerText: tenderItemGroup.name
            });
            */
          }

          angular.forEach($filter('orderBy')(tenderItemGroup.items, 'order'), function(item) {
            $scope.reportLines.push(item);
          });

          if (tenderItemGroup.name) {
            // Super Item Group footer (but only if it's not the default super item group)
            $scope.reportLines.push({
              isFooter: true,
              rowClass: 'totals-row',
              isValueLine: true,
              whenTendered: tenderItemGroup.whenTendered,
              footerText: tenderItemGroup.name + ' Subtotals',
              tenderLineType: tenderItemGroup.tenderLineType,
              // invoiceTotal: tenderItemGroup.invoiceTotal,
              tip: tenderItemGroup.tip,
              change: tenderItemGroup.change,
              tendered: tenderItemGroup.tendered
            });
          }

        });

        // Sale Category footer
        $scope.reportLines.push({
          isFooter: true,
          rowClass: 'totals-row',
          isValueLine: true,
          whenTendered: till.whenTendered,
          footerText: 'Subtotals for ' + till.name,
          tenderLineType: till.tenderLineType,
          // invoiceTotal: till.invoiceTotal,
          tip: till.tip,
          change: till.change,
          tendered: till.tendered
        });

      });

      // Outlet footer
      $scope.reportLines.push({
        isFooter: true,
        rowClass: 'totals-row',
        isValueLine: true,
        whenTendered: outlet.whenTendered,
        footerText: 'Subtotals for ' + outlet.name,
        tenderLineType: outlet.tenderLineType,
        // invoiceTotal: outlet.invoiceTotal,
        tip: outlet.tip,
        change: outlet.change,
        tendered: outlet.tendered
      });
    });
  });

}]);
